import React, { useRef, useState } from 'react';
import CommunityHeroSection from '../../../components/landingPage/CommunityPage/CommunityHeroSection';
import CommunityEcosystemSection from '../../../components/landingPage/CommunityPage/CommunityEcosystemSection';
import CommunityPeopleSection from '../../../components/landingPage/CommunityPage/CommunityPeopleSection';
import CommunityStatsSection from '../../../components/landingPage/CommunityPage/CommunityStatsSection';
import CommunityCtaSection from '../../../components/landingPage/CommunityPage/CommunityCtaSection';
import CommunityEventsSection from '../../../components/landingPage/CommunityPage/CommunityEventsSection';
import { useReveal } from '../../../components/landingPage/common/landingHooks';

const TABS = [{ id: 'community', label: 'Community' }, { id: 'events', label: 'Events' }];

const LandingHomeCommunity = () => {
    const rootRef = useRef(null);
    const [tab, setTab] = useState('community');
    // Reason: keyed on the active tab so useReveal re-runs and observes the newly mounted sections —
    // without it, switching tabs leaves the incoming content stuck at opacity 0.
    useReveal(rootRef, tab);

    return (
        <div className="lp-page" ref={rootRef}>
            <div className="lp-cm-tabbar">
                <div className="lp-cm-tabbar-inner">
                    {TABS.map(t => (
                        <button key={t.id} type="button" className={`lp-cm-tab${tab === t.id ? ' is-active' : ''}`} onClick={() => setTab(t.id)}>{t.label}</button>
                    ))}
                </div>
            </div>

            {tab === 'community' ? (
                <>
                    <CommunityHeroSection />
                    <CommunityEcosystemSection />
                    <CommunityPeopleSection />
                    <CommunityStatsSection />
                    <CommunityCtaSection />
                </>
            ) : (
                <CommunityEventsSection />
            )}
        </div>
    );
};

export default LandingHomeCommunity;
